import { SubFund, PaginationMeta, SubFundFilter } from '../types';

export interface ISubFundState {
  subFunds: SubFund[];
  subFundPaginationMeta: PaginationMeta;
  filterSubFunds: SubFund[];
  appliedFilters: SubFundFilter;
}

export const SubFundState: ISubFundState = {
  subFunds: [],
  subFundPaginationMeta: {} as PaginationMeta,
  filterSubFunds: [],
  appliedFilters: {
    selectedSubFundEntities: [],
    selectedSubFundIds: [],
    selectedReportingPeriods: [],
    searchKeyword: ''
  }
};
